import type {
  Permission,
  ImpersonationPermission,
} from 'walden-fast/types/fast-backend/user';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_IMPERSONATION_PERMISSION: ImpersonationPermission = {
  $type: 'Impersonation',
  properties: {
    allowedAccountsToImpersonate: [
      {
        id: '33333',
        displayName: 'Imposter',
      },
      {
        id: '1555',
        displayName: 'User Company',
      },
    ],
    allowedClientCompaniesToImpersonate: [],
  },
  granted: true,
};

export const permissionFactory: Factory<Permission> = (overrides) => ({
  ...MOCK_IMPERSONATION_PERMISSION,
  ...overrides,
});
